
import Vue from "vue";
import Currencies from "../../utils/Currencies"
export default Vue.extend({
  props: [
    "showSplit",
    "showLineSum",
    "showUnitCost",
    "showDayRate",
    "showBudgetLumpSum",
  ],
  data() {
    return {
      selectedTemplate: null,
    };
  },
  computed: {
    budgetTemplateOptions(): any {
      return this.$store.getters[
        "budgetTemplateModule/getAllTemplates"
      ].map((thisBudgetTemplate: any) => ({
        value: thisBudgetTemplate.id,
        text: thisBudgetTemplate.templateName,
      }));
    },
    currencyOptions():Array<any>{
      let currencies: Array<any> = []
      for(var c in Currencies){
        currencies.push({text:c,value:c})
      }
      return currencies
    }
  },
  methods:{
    selectionChanged(){
      this.$emit("templateSelectionChanged",this.selectedTemplate);
    }
  },
  mounted() {
    if (this.budgetTemplateOptions.length < 1) {
      this.$store.dispatch("budgetTemplateModule/fetchBudgetTemplates");
    }
  },
});
